import React, { useContext, useReducer } from "react";
import axios from "axios";
import reducer from "../reducers/match_reducer";
import { match_detail_url } from "../utils/constants";
import {
  UPDATE_MATCH_GAME_IDS,
  MATCH_LOADING_IN_PROGRESS,
  MATCH_LOADING_COMPLETED,
  MATCH_LOADING_ERROR,
  MATCH_UPDATING_IN_PROGRESS,
  MATCH_UPDATING_COMPLETED,
  MATCH_UPDATING_ERROR,
} from "../actions";
import _ from "lodash";

const initialState = {
  updating: false,
  updatingError: false,
  loading: false,
  error: false,
  match: null,
  gameIds: null,
};

var gamesTemplate_PA3 = [
  {
    sequence: 1,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 2,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 3,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
];

var gamesTemplate_BO5 = [
  {
    sequence: 1,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 2,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 3,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 4,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 5,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
];

const mergeGames = (games, template, fields) => {
  var toRet = [...template];

  for (const game of toRet) {
    for (const temp of games) {
      if (game.sequence === temp.sequence) {
        for (const field of fields) {
          game[field] = temp[field];
        }
        break;
      }
    }
  }
  return toRet;
};

const MatchContext = React.createContext();

export const MatchProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchMatch = async (matchId) => {
    console.log("match_context :: fetchMatch");
    if (
      matchId &&
      !state.loading &&
      (!state.match || state.match.matchId !== matchId)
    ) {
      //console.log(`MatchContext :: Loading match data ${matchId}`);
      const url = `${match_detail_url.replace(":matchId", matchId)}`;
      dispatch({
        type: MATCH_LOADING_IN_PROGRESS,
      });

      try {
        const response = await axios.get(url);
        if (response.status === 200) {
          //console.log(response.data);
          var infoMatch = {
            match: { ...response.data },
            gameIds: [
              ...response.data.games.map((game) => {
                return {
                  sequence: game.sequence,
                  gameAoe2Id: game.gameAoe2Id,
                };
              }),
            ],
          };
          //console.log(infoMatch);
          dispatch({
            type: MATCH_LOADING_COMPLETED,
            payload: { ...infoMatch },
          });
        } else {
          dispatch({
            type: MATCH_LOADING_ERROR,
          });
        }
      } catch (error) {
        dispatch({ type: MATCH_LOADING_ERROR });
      }
    }
  };

  const updateMatchInfo = async (match) => {
    if (!state.loading) {
      //console.log("****************** updateMatchInfo ******************");
      console.log(match);
      console.log(state);
      const maxLength = match.gamesFormat === "PA3" ? 3 : 5;

      var gamesTemplate =
        match.gamesFormat === "PA3" ? gamesTemplate_PA3 : gamesTemplate_BO5;

      /* console.log(
        `updateMatchInfo :: gameFormat=${match.gamesFormat} => maxLength=${maxLength}`
      );
      console.log(gamesTemplate); */

      var gamesInfo = [...gamesTemplate];
      if (match.games && match.games.length === maxLength) {
        gamesInfo = mergeGames(match.games, gamesInfo, [
          "gameWinner",
          "gameCivA",
          "gameCivB",
          "map",
          "gameRec",
        ]);
      }
      if (match.gameIds && match.gameIds.length === maxLength) {
        gamesInfo = mergeGames(match.gameIds, gamesTemplate, ["gameAoe2Id"]);
      }

      let matchInfo = { ...match, games: gamesInfo };
      console.log(matchInfo);

      var access_token = localStorage.getItem("access_token");
      if (!access_token) {
        console.error(
          `match_context :: updateMatchInfo -> it's necessary be logged`
        );
        return false;
      }
      const config = {
        headers: { Authorization: `Bearer ${access_token}` },
      };

      dispatch({ type: MATCH_UPDATING_IN_PROGRESS, payload: { ...matchInfo } });

      try {
        var data = { ...matchInfo };
        const response = await axios.put(
          `${match_detail_url.replace(":matchId", matchInfo.matchId)}`,
          data,
          config
        );
        if (response.status === 201) {
          console.log(`updateMatchInfo :: info actualizada`);
          console.log(response.data);
          /* var infoMatch = {
            match: { ...response.data },
            gameIds: [
              ...response.data.games.map((game) => {
                return {
                  sequence: game.sequence,
                  gameAoe2Id: game.gameAoe2Id,
                };
              }),
            ],
          }; */
          //console.log(infoMatch);
          dispatch({
            type: MATCH_UPDATING_COMPLETED,
            payload: { ...matchInfo },
          });
        } else {
          dispatch({
            type: MATCH_UPDATING_ERROR,
          });
        }
      } catch (error) {
        dispatch({ type: MATCH_UPDATING_ERROR });
      }
    } else {
      console.log(`There is an update in progress`);
    }
  };

  const updateAutomFields = (match) => {
    var toRet = { ...match };

    if (
      match.playerAaw === "AW" ||
      match.playerAaw === "AL" ||
      match.playerBaw === "AW" ||
      match.playerBaw === "AL"
    ) {
      return toRet;
    }

    // update State
    const maxCounterWins = 3;
    const maxGames = match.gamesFormat === "PA3" ? 3 : 5;
    let counterWinsA = 0;
    let counterWinsB = 0;
    let games = 0;
    for (var i = 0; i < match.games.length; i++) {
      if (match.games[i].gameWinner === match.playerAid) {
        games = games + 1;
        counterWinsA = counterWinsA + 1;
      }
      if (match.games[i].gameWinner === match.playerBid) {
        games = games + 1;
        counterWinsB = counterWinsB + 1;
      }
    }

    if (
      (counterWinsA === maxCounterWins ||
        counterWinsB === maxCounterWins ||
        games === maxGames) &&
      toRet.status !== "REVIEWED" &&
      toRet.status !== "FINISHED"
    ) {
      toRet.status = "FINISHED";
    }

    toRet.playerAresult = counterWinsA;
    toRet.playerBresult = counterWinsB;

    return toRet;
  };

  const updateMatchGameIds = (gameIds) => {
    console.log("match_context :: updateMatch-Games");
    dispatch({
      type: UPDATE_MATCH_GAME_IDS,
      payload: { gameIds: gameIds },
    });
  };

  const updateMatch = (match) => {
    console.log("match_context :: updateMatch");
    console.log(match);
    console.log(state);

    if (
      _.isEqual(state.match, match) &&
      _.isEqual(state.match.games, match.games)
    ) {
      console.log(">>>> match_context.updateMatch :: no update");
    } else {
      console.log(">>>> match_context.updateMatch :: update");
      updateMatchInfo(updateAutomFields(match));
      /* dispatch({
        type: UPDATE_MATCH,
        payload: { match: updateAutomFields(match) },
      }); */
    }
  };

  return (
    <MatchContext.Provider
      value={{
        ...state,
        fetchMatch,
        updateMatch,
        updateMatchGameIds,
      }}
    >
      {children}
    </MatchContext.Provider>
  );
};
// make sure use
export const useMatchContext = () => {
  return useContext(MatchContext);
};
